module.exports = __webpack_public_path__ + "media/images/products/about/support-e5a0c491ca16be78303767e376a00912.png";